import 'arrive';
import $ from 'jquery';

document.arrive('.navbar', {existing: true}, function() {

  var $navbar = $(this);

  $(document).scroll(function() {

    var scrollYPosition = window.pageYOffset;

    if (scrollYPosition > 20) {
      $navbar.addClass('scrolled');
    } else {
      $navbar.removeClass('scrolled');
    }

  });

});
